import { Star } from "lucide-react";

export const TestimonialCard = ({ testimonial }) => {
  return (
    <div
      className="bg-neutral-800 p-8 md:p-10 border border-neutral-700"
      data-testid={`testimonial-${testimonial.id}`}
    >
      {/* Quote mark */}
      <div className="font-heading text-6xl leading-none text-neutral-600 mb-4">"</div>

      {/* Content */}
      <p className="text-gray-300 text-lg leading-relaxed mb-6">
        {testimonial.content}
      </p>

      {/* Rating */}
      <div className="flex gap-1 mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-white text-white" />
        ))}
      </div>

      {/* Author */}
      <div className="border-t border-neutral-600 pt-4">
        <p className="font-heading font-semibold text-white">
          {testimonial.name}
        </p>
        {testimonial.company && (
          <p className="text-gray-400 text-sm">{testimonial.company}</p>
        )}
        <p className="text-gray-400 text-sm">{testimonial.location}</p>
        {testimonial.service_type && (
          <p className="text-gray-500 text-xs uppercase tracking-widest mt-2">
            {testimonial.service_type}
          </p>
        )}
      </div>
    </div>
  );
};

export default TestimonialCard;
